import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { FlatButton, TransparentFlatButton } from '@ui/buttons';
import { Container } from '@ui';
import { useScreenSize } from '@hooks';
import { ROUTES } from '@constants/routes';
import { useLocationUpdate } from '@hooks/application/useLocationSafe';
import { SCREEN_SIZES } from '@constants/screen';
import { FullLogo } from '@assets/logos/FullLogo';
import { Link } from 'react-router-dom';
import { selectLightTheme } from '@utils/themes';

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: ${({ isMobile }) => (isMobile ? '60px' : '64px')};
  padding: ${({ isMobile }) => (isMobile ? '0 12px' : '0 24px')};

  background: ${({ theme }) => selectLightTheme(theme).header};
`;
const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  max-width: ${({ largeWidth }) => (largeWidth ? '1880px' : '1440px')};
  margin: 0 auto;
`;

const DesktopLogoWrapper = styled.div`
  svg {
    width: 160px;
    fill: ${({ theme }) => selectLightTheme(theme).text} !important;

    * {
      fill: ${({ theme }) => selectLightTheme(theme).text} !important;
    }
  }
`;
const MobileLogoWrapper = styled.div`
  svg {
    width: 120px;
    fill: ${({ theme }) => selectLightTheme(theme).text} !important;

    * {
      fill: ${({ theme }) => selectLightTheme(theme).text} !important;
    }
  }
`;
const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const GetStartedButtonWrapper = styled.div`
  button {
    padding: 18px 40px;

    background: ${({ theme }) => selectLightTheme(theme).text} !important;
    border-bottom: 1px solid ${({ theme }) => selectLightTheme(theme).text} !important;

    * {
      color: ${({ theme }) => selectLightTheme(theme).buttonText} !important;
    }
  }
`;
const LoginButtonWrapper = styled.div`
  button {
    padding: 16px 24px;

    * {
      color: ${({ theme }) => selectLightTheme(theme).text} !important;
    }
  }
`;
const GetStartedButtonMobileWrapper = styled.div`
  button {
    padding: 12px 12px;

    background: ${({ theme }) => selectLightTheme(theme).text} !important;
    border-bottom: 1px solid ${({ theme }) => selectLightTheme(theme).text} !important;

    * {
      color: ${({ theme }) => selectLightTheme(theme).buttonText} !important;
    }
  }
`;
const LoginButtonMobileWrapper = styled.div`
  button {
    padding: 12px 12px;
  }
`;

const NavLinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;

  a {
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.06em;

    text-decoration: none;
    text-transform: uppercase;
    color: ${({ theme }) => selectLightTheme(theme).text};

    * {
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.06em;
      color: ${({ theme }) => selectLightTheme(theme).text};
    }
  }
`;

function HeaderActions({ isMobile }) {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate(ROUTES.login);
  };
  const handleGetStartedClick = () => {
    navigate(ROUTES.signup);
  };

  if (isMobile) {
    return (
      <Container row verticallyCenter>
        <LoginButtonMobileWrapper>
          <TransparentFlatButton onClick={handleLoginClick}>Login</TransparentFlatButton>
        </LoginButtonMobileWrapper>
        <GetStartedButtonMobileWrapper>
          <FlatButton onClick={handleGetStartedClick}>Get Started</FlatButton>
        </GetStartedButtonMobileWrapper>
      </Container>
    );
  }

  return (
    <Container row verticallyCenter>
      <LoginButtonWrapper>
        <TransparentFlatButton onClick={handleLoginClick}>Login</TransparentFlatButton>
      </LoginButtonWrapper>
      <GetStartedButtonWrapper>
        <FlatButton onClick={handleGetStartedClick}>Get Started</FlatButton>
      </GetStartedButtonWrapper>
    </Container>
  );
}

function NavLinks() {
  return (
    <NavLinksWrapper>
      {/*<Link to={'/about'}>*/}
      {/*  <Body5 bold>About</Body5>*/}
      {/*</Link>*/}
      {/*<Link to={'/faq'}>*/}
      {/*  <Body5 bold>FAQ</Body5>*/}
      {/*</Link>*/}
    </NavLinksWrapper>
  );
}

export function Navbar({ isLoadingState, largeWidth }) {
  const screenSize = useScreenSize();
  const isMobile = screenSize === SCREEN_SIZES.mobile;

  useLocationUpdate();

  if (isMobile) {
    return (
      <OuterWrapper isMobile>
        <Wrapper largeWidth={largeWidth}>
          {isLoadingState ? null : (
            <Link to={'/'}>
              <MobileLogoWrapper>
                <FullLogo forceTornado />
              </MobileLogoWrapper>
            </Link>
          )}
          <HeaderActions isLoadingState={isLoadingState} isMobile />
        </Wrapper>
      </OuterWrapper>
    );
  }
  return (
    <OuterWrapper>
      <Wrapper largeWidth={largeWidth}>
        <LeftWrapper>
          {isLoadingState ? null : (
            <Link to={'/'}>
              <DesktopLogoWrapper>
                <FullLogo forceTornado />
              </DesktopLogoWrapper>
            </Link>
          )}
        </LeftWrapper>
        <NavLinks />
        <HeaderActions isLoadingState={isLoadingState} />
      </Wrapper>
    </OuterWrapper>
  );
}
